

<header>
  <div class="nav-row">
    <div class="brand">
      <div class="mark">U</div>
      <div style="color: #fff">UMYO ESPAÑOL<small>FOR US. BY US. POWERED BY UMYO.</small></div>
    </div>
    <ul class="nav-links">
      <li><a href="#home">HOME</a></li>
      <li><a href="#about">ABOUT US</a></li>
      <li><a href="#screening">SCREENING</a></li>
      <li><a href="#community">COMMUNITY</a></li>
      <li><a href="#benefits">BENEFITS</a></li>
      <li><a href="#faq">FAQ</a></li>
    </ul>
    <a href="/home" class="btn nav-cta">ENTER NOW</a>
  </div>
</header>

<!-- HERO -->
<section class="hero" id="home" style="border-bottom:1px solid var(--line);">
  <div class="wrap hero-inner">
    <h1>50 PEOPLE. ONE MOVIE.<br><span>$10 EACH.</span></h1>
    <p class="sub">Hollywood doesn't have to decide which stories get told. We can.</p>
    <div class="price-pill">
      <div class="icon">▶</div>
      <div class="txt">
        <b>YOUR FIRST $10 OPENS THE DOOR.</b>
        Join in Month One and get access to experience the movie when it's officially released through the participating platform.
      </div>
    </div>
    <div style="margin-top:6px;">
      <div class="equation">50 PEOPLE <span class="hl">×</span> $10 <span class="hl">=</span> $500</div>
    </div>
    <div style="margin-top:30px;">
      <a href="/home" class="btn">ENTER NOW</a>
    </div>
  </div>
</section>

<!-- OUR MOMENT -->
<section class="moment" id="about">
  <div class="wrap">
    <div class="moment-hero">
      <!-- <img src="assets/images/crowd-sunset.png" alt=""> -->
      <div class="content">
        <div class="eyebrow">FOR US. BY US. POWERED BY US.</div>
        <h2>THIS IS OUR MOMENT.</h2>
        <div class="tag-row">
          <span class="tag">LATINOS</span>
          <span class="tag">MEXICANS</span>
          <span class="tag">PUERTO RICANS</span>
          <span class="tag">HISPANICS</span>
        </div>
        <p>One culture. One digital community. One powerful movement. Hear directly from community leaders and founding voices — see what's coming.</p>
      </div>
    </div>

    <div class="video-grid">
      <div class="video-card">
      	<img class="img-fluid" src="assets/images/Woman_smiling.jpeg">
        <!-- <span class="placeholder-note">Video coming soon</span>
        <div class="avatar">CL</div>
        <div class="play">▶</div>
        <div class="label"><b>COMMUNITY LEADER</b><span>Special Message</span></div> -->
      </div>
      <div class="video-card">
      	<img class="img-fluid" src="assets/images/Man_wearing_round.jpeg">
        <!-- <span class="placeholder-note">Video coming soon</span>
        <div class="avatar">FM</div>
        <div class="play">▶</div>
        <div class="label"><b>FOUNDING MEMBER</b><span>Special Message</span></div> -->
      </div>
      <div class="video-card">
      	<img class="img-fluid" src="assets/images/andy_garcia.jpeg">
        <!-- <span class="placeholder-note">Video coming soon</span>
        <div class="avatar">+3</div>
        <div class="play">▶</div>
        <div class="label"><b>SPECIAL GUESTS</b><span>And More…</span></div> -->
      </div>
    </div>
    <div class="center-btn"><a href="javascript: void(0)" class="btn">WATCH ALL VIDEOS</a></div>
  </div>
</section>

<!-- SCREENING -->
<section id="screening">
  <div class="wrap screening-grid">
    <div>
      <div class="eyebrow">50 PEOPLE WILL BE SELECTED</div>
      <h2 style="font-size:28px;">For an exclusive <span style="color:var(--gold);">private screening experience</span></h2>
      <div class="perks">
        <div class="perk"><div class="ico">🎬</div><span>Private Screening</span></div>
        <div class="perk"><div class="ico">👥</div><span>Meet the Cast</span></div>
        <div class="perk"><div class="ico">📷</div><span>Photos &amp; Memories</span></div>
        <div class="perk"><div class="ico">⭐</div><span>Special Guests</span></div>
      </div>
      <a href="/home" class="btn">ENTER FOR YOUR OPPORTUNITY →</a>
    </div>

    <div class="film-card">
      <div class="eyebrow">AN INSPIRING TRUE STORY</div>
      <h3>CELIO<br>"EL FLACO DE ORO"</h3>
      <div class="tagline">THE GOLDEN VOICE</div>
      <div class="film-visual"><span class="mic">🎤</span></div>
      <div class="cast-row">
        <b>Starring</b>
        Cast to be announced — reveal coming soon.
      </div>
      <p style="font-size:13px;color:#fff;margin-top:16px;">An intimate movie experience with participating actors, actresses, filmmakers and special guests.</p>
    </div>
  </div>
</section>

<!-- COMMUNITY -->
<section class="community" id="community">
  <div class="wrap">
  	<div>
	    <div class="eyebrow" style="color:#fff;opacity:.85;">BUT THIS IS BIGGER THAN A MOVIE.</div>
	    <h2 style="font-size:30px;max-width:520px;">We're building something for our people.</h2>
	    <p style="max-width:480px;color:#fff;margin-top:14px;font-size:14px;">Imagine 50 of us connected inside one digital community.</p>

	    <div class="pillars">
	      <div class="pillar"><div class="ico">👤</div>Our People</div>
	      <div class="pillar"><div class="ico">🏢</div>Our Businesses</div>
	      <div class="pillar"><div class="ico">🎨</div>Our Creators</div>
	      <div class="pillar"><div class="ico">🌎</div>Our Culture</div>
	      <div class="pillar"><div class="ico">💠</div>Our Technology</div>
	    </div>
	</div>

    <div style="display:flex;justify-content: center; align-items:center;" id="benefits">
      <div class="stats-card">
        <h3>1,000,000</h3>
        <p><b style="color:var(--gold);">REGISTERED MEMBERS</b> — then we begin giving back, every month. Eligible members will have opportunities to receive community hardship assistance.</p>
        <div class="benefit-grid">
          <div class="benefit"><b>$50</b>Gas</div>
          <div class="benefit"><b>$200</b>Food</div>
          <div class="benefit"><b>$200</b>Visa Card</div>
          <div class="benefit"><b>$150</b>Electricity</div>
          <div class="benefit"><b>$500</b>Car Note</div>
          <div class="benefit"><b>$1,000</b>Rent/Mortgage</div>
        </div>
        <a href="#" class="btn btn-gold" style="width:100%;text-align:center;">SEE INSIDE FOR DETAILS →</a>
      </div>
    </div>
  </div>

  <div style="display:flex;justify-content: center; align-items:center;text-align: center;">

    <div style="margin-top:40px;">
      <div class="eyebrow" style="color:#fff;">A DIGITAL SPANISH COMMUNITY</div>
      <h2 style="font-size:24px;">For us. By us. Powered by us.</h2>
      <div class="join-row">
        <div><span>①</span> Join</div>
        <div><span>②</span> Connect</div>
        <div><span>③</span> Share</div>
        <div><span>④</span> Empower</div>
        <div><span>⑤</span> Grow</div>
      </div>
      <a href="/home" class="btn" id="enter">JOIN THE MOVEMENT →</a>
    </div>
  </div>
</section>

<footer id="faq" style="background: #000;">
  <div class="wrap">
    <p>Private screening participation, talent appearances, videos, eligibility, selection procedures, community assistance and other benefits are subject to applicable terms and conditions. UMYO is not affiliated with or endorsed by any actors, musicians or public figures referenced on this page unless explicitly stated and confirmed.</p>
  </div>
</footer>
